'use strict';

var Bacon, R, addressStore, availableOrderTimes, availableOrderTypes, availableTenderTypes, availableTipTypes, cartStore, cartStreamData, findRestaurantAddress, findUserAddress, intPropEq, labelToNameRenamer, makeDateTime, moment, orderTimeActiveStream, orderTypeActiveStream, orderTypeErrors, orderTypeStream, orderTypeValue, resUtil, restaurantStore, selectedOrderTime, selectedOrderType, selectedTender, selectedTip, setSelectedType, setSelectedValue, settingsBuilder, settingsStream, tenderActiveStream, tenderErrors, tenderStream, tenderValue, timeTypeErrors, timeTypeStream, timeTypeValue, tipActiveStream, tipErrors, tipStream, tipValue, updateSettingsType, updateSettingsValue, userStore;

Bacon = require('baconjs');

R = require('ramda');

moment = require('moment');

restaurantStore = require('../restaurants-gql');

userStore = require('../user');

addressStore = require('../address');

resUtil = require('../../utils/resources');

cartStore = require('./index');

cartStreamData = cartStore.cart;

// ************* SETTINGS
labelToNameRenamer = resUtil.renameProp('label', 'name');

settingsStream = cartStreamData.filter(R.compose(R.not, R.isNil)).map(R.prop('settings'));

// ************* SETTINGS - ORDER TYPE
orderTypeStream = settingsStream.map(R.prop('order'));

availableOrderTypes = orderTypeStream.map(R.prop('types')).map(R.map(labelToNameRenamer));

selectedOrderType = orderTypeStream.map(R.prop('selected')).combine(availableOrderTypes, function (orderType, types) {
  return R.find(R.propEq('id', orderType), types);
});

orderTypeErrors = orderTypeStream.map(R.pick(['errors', 'info']));

intPropEq = R.curry(function (prop, value) {
  return R.compose(R.equals(value), parseInt, R.prop(prop));
});

findUserAddress = function findUserAddress(address_id) {
  return userStore.addresses.map(R.filter(intPropEq('id', address_id))).map(R.nth(0));
};

findRestaurantAddress = function findRestaurantAddress(address_id) {
  return restaurantStore.restaurant.map(R.prop('locations')).map(R.filter(intPropEq('id', address_id))).map(R.nth(0));
};

orderTypeValue = orderTypeStream.map(R.prop('value')).combine(selectedOrderType, function (value, type) {
  return { value: value, type: type };
}).flatMap(function (_ref) {
  var value = _ref.value,
      type = _ref.type;

  switch (type.id) {
    case 'DELIVERY':
      return findUserAddress(value);
    case 'PICKUP':
      return findRestaurantAddress(value);
    case 'DINEIN':
      return findRestaurantAddress(value);
    case 'CURBSIDE':
      return Bacon.once(value);
  }
}).toProperty();

orderTypeActiveStream = orderTypeStream.map(R.prop('active'));

// ************* SETTINGS - TIME TYPE
timeTypeStream = settingsStream.map(R.prop('time'));

availableOrderTimes = timeTypeStream.map(R.prop('types'));

selectedOrderTime = timeTypeStream.map(R.prop('selected')).combine(availableOrderTimes, function (timeTypeId, types) {
  return R.defaultTo({
    id: null
  })(R.find(R.propEq('id', timeTypeId), types));
});

timeTypeErrors = timeTypeStream.map(R.pick(['errors', 'info']));

makeDateTime = function makeDateTime(dateTime) {
  if (dateTime) {
    return moment(dateTime).toDate();
  } else {
    return null;
  }
};

timeTypeValue = timeTypeStream.map(R.prop('value')).map(makeDateTime).toProperty();

orderTimeActiveStream = timeTypeStream.map(R.prop('active'));

// ************* SETTINGS - TENDER
tenderStream = settingsStream.map(R.prop('tender'));

availableTenderTypes = tenderStream.map(R.prop('types')).map(R.map(labelToNameRenamer));

tenderErrors = tenderStream.map(R.pick(['errors', 'info']));

selectedTender = tenderStream.map(R.prop('selected')).combine(availableTenderTypes, function (tenderId, types) {
  return R.find(R.propEq('id', tenderId), types);
});

tenderValue = tenderStream.map(R.prop('value'));

tenderActiveStream = tenderStream.map(R.prop('active'));

// ************ SETTINGS - TIP
tipStream = settingsStream.map(R.prop('tip'));

availableTipTypes = tipStream.map(R.prop('types'));

tipErrors = tipStream.map(R.pick(['errors', 'info']));

selectedTip = tipStream.map(R.prop('selected')).combine(availableTipTypes, function (tipId, types) {
  return R.find(R.propEq('id', tipId), types);
});

tipValue = tipStream.map(R.prop('value'));

tipActiveStream = tipStream.map(R.prop('active'));

settingsBuilder = R.curry(function (ok, key, section, value) {
  return R.assocPath(['cart', section, key], value, {});
});

setSelectedType = settingsBuilder('selected', 'type');

setSelectedValue = settingsBuilder('value', 'value');

updateSettingsType = function updateSettingsType(key, returnStream) {
  return R.pipe(R.prop('id'), setSelectedType(key), cartStore.updateSettings, R.always(returnStream.toEventStream()));
};

updateSettingsValue = function updateSettingsValue(key, returnStream) {
  return R.pipe(setSelectedValue(key), cartStore.updateSettings, R.always(returnStream.toEventStream()));
};

module.exports = {
  orderType: {
    active: orderTypeActiveStream,
    available: availableOrderTypes,
    selected: selectedOrderType,
    errors: orderTypeErrors,
    value: orderTypeValue,
    setSelection: updateSettingsType('order', selectedOrderType),
    setValue: updateSettingsValue('order', orderTypeValue)
  },
  orderTime: {
    active: orderTimeActiveStream,
    available: availableOrderTimes,
    selected: selectedOrderTime,
    errors: timeTypeErrors,
    value: timeTypeValue,
    setSelection: updateSettingsType('time', selectedOrderTime),
    setValue: updateSettingsValue('time', timeTypeValue)
  },
  tender: {
    active: tenderActiveStream,
    available: availableTenderTypes,
    selected: selectedTender,
    errors: tenderErrors,
    value: tenderValue,
    setSelection: updateSettingsType('tender', selectedTender),
    setValue: updateSettingsValue('tender', tenderValue),
    setSelectionAndValue: function setSelectionAndValue(selection, value) {
      cartStore.updateSettings({
        cart: {
          tender: {
            type: selection.id,
            value: value
          }
        }
      });
      return tenderStream.toEventStream();
    }
  },
  tip: {
    active: tipActiveStream,
    available: availableTipTypes,
    selected: selectedTip,
    errors: tipErrors,
    value: tipValue,
    setSelection: updateSettingsType('tip', selectedTip),
    setValue: updateSettingsValue('tip', tipValue)
  }
};